import routerOptions0 from "/usr/src/app/content/n3-promos-a9d41bd4-ff25-4c48-ad5c-e2a20ff2d080/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}